import React, { Component } from 'react';
//import {Alert} from 'react-bootstrap';
import { Jumbotron, Form, Col, Table, Button, Row } from 'react-bootstrap';
//import {Toast} from 'react-bootstrap';
import config from '../../../config';
import { IoIosRemoveCircle } from "react-icons/io";
import { IconContext } from "react-icons";
import Numeroaletras from '../../../middleware/numbertoletter';
import ModalConfirm from '../../subcomponent/modalConfirm';
import funciones from '../../../middleware/funciones';
import SearchItem from '../../subcomponent/searchItem';
import SearchClient from '../../subcomponent/searchClient';
import ModalImpresion from '../../subcomponent/modalImpresion';
import BackButton from '../../widgets/back_button';
import { toast } from '../../widgets/alerts/Toast';
import './pedidos.css';

class Pedidos extends Component {
    constructor(props) {
        const currentCompany = sessionStorage.getItem('company');
        const currentUserType = sessionStorage.getItem('tipo');
        const currentUser = sessionStorage.getItem('vendedor');
        const user = sessionStorage.getItem('_id');
        super(props);
        this.state = {
            data: [],
            empresa: currentCompany,
            tipo: currentUserType,
            currentUser,
            user,
            clientes: [],
            prefijos: [],
            forma_pago: [],
            vendedores: [],
            retenciones: [],
            bodegas: [],
            PREFIJO: "",
            FORMA_PAGO: "",
            NUMERO_FACTURA: 0,
            CLIENTE: "",
            FECHA_ENTREGA: "",
            cod_lista: "",
            RENTA: 0,
            RETEIVA: 0,
            RETEICA: 0,
            RETEOTROS: 0,
            VENDEDOR_SELECTED: "",
            OBSERVACION_FACTURA: "",
            ORDEN_COMPRA: "",
            mostrar_prefijo: "",
            defaultDocOrder: "",
            tipo_pref: "",
            forma_pago_cliente: "",
            tope: 100,
            bodegadefault: "",
            SHOW_DETAIL: false,
            data_items: [],
            items_barcode: [],
            detalle_factura: [],
            data_cliente: [],
            promociones: [],
            promociones_grupo: [],
            totales: {
                TOTAL_BRUTO: 0,
                RETENCION: 0,
                TOTAL_IVA: 0,
                SUBTOTAL: 0,
                TOTAL_DESCUENTOS: 0,
                TOTAL_PAGAR: 0
            },
            showPress: false,
            mensajeImp: ''
        };
    }
    componentDidMount() {
        this.initFactura();
    }

    initFactura = () => {
        const today = new Date();
        const dd = String(today.getDate()).padStart(2, '0');
        const mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!mm
        const yyyy = today.getFullYear();
        const cfecha = yyyy + "-" + mm + "-" + dd;
        const { currentUser } = this.state;
        const datasend = {
            method: 'GET',

            headers: {
                'Content-Type': 'application/json',
                'empresa': this.state.empresa,
                'tipo': 'PE',
                'currentUser': currentUser,
            }
        }
        fetch(config.servBackEnd + '/invoice/', datasend).then(response => response.json())
            .then(data => {
                const cData = data.data;
                const clientes = cData[0];
                const prefijos = cData[5];
                const forma_pago = cData[2];
                const vendedores = cData[3];
                const retenciones = cData[4];
                const bodegas = cData[6];
                const infovendedor = cData[8];
                let tope = 100;
                let bodegadefault = "";
                let mostrar_prefijo = "";
                let defaultDocOrder = "";
                let PREFIJO = "";
                if (infovendedor.length > 0) {
                    tope = infovendedor[0]["TOPE_DSCTO"];
                    bodegadefault = infovendedor[0]["BODEGA"];
                    mostrar_prefijo = infovendedor[0]["MOSTRAR_PREFIJO"];
                    defaultDocOrder = infovendedor[0]["PEDIDO"];
                    if (!mostrar_prefijo) {
                        PREFIJO = defaultDocOrder;
                    }
                }
                this.setState({
                    clientes,
                    prefijos,
                    forma_pago,
                    vendedores,
                    retenciones,
                    defaultDocOrder,
                    PREFIJO,
                    tope,
                    bodegadefault,
                    mostrar_prefijo,
                    FORMA_PAGO: "",
                    NUMERO_FACTURA: 0,
                    CLIENTE: "",
                    FECHA_ENTREGA: cfecha,
                    FECHA_CREACION: cfecha,
                    SHOW_DETAIL: false,
                    bodegas
                });
                this.clearItem();
            });
    }
    changePrefijo = ({ target }) => {
        const numero = target.selectedOptions[0].title;
        let showDetail = false;
        if (numero && this.state.CLIENTE !== "") {
            showDetail = true
        }
        this.setState({
            PREFIJO: target.value,
            NUMERO_FACTURA: numero,
            SHOW_DETAIL: showDetail
        });

    }

    changeCantidad = ({ target }, position) => {
        const newDetalle = this.state.detalle_factura;
        let { value } = target;
        const { name } = target;
        if (name === "DESCUENTO" && value > 100) value = 100;
        newDetalle.forEach((element, index) => {
            if (position === index) {
                element[name] = value;
            };
        });
        this.setState({ detalle_factura: newDetalle });
        this.calcTotales();
    }

    calcTotales = () => {
        const newDetalle = this.state.detalle_factura;
        const { retenciones } = this.state;
        const { data_cliente } = this.state;
        const { cod_lista } = this.state;
        const promociones = this.state.promociones;
        let RENTA = 0;
        let RETEIVA = 0;
        let RETEICA = 0;
        let RETEOTROS = 0;
        let TOTAL_BRUTO = 0;
        let RETENCION = 0;
        let TOTAL_IVA = 0;
        let SUBTOTAL = 0;
        let TOTAL_DESCUENTOS = 0;
        let TOTAL_PAGAR = 0;
        newDetalle.forEach(element => {
            if (cod_lista !== 0) {
                const actprom = promociones.find((promo) => promo.ID_ITEM === element.ID_ITEMS && promo.CANT_FINAL >= parseInt(element.CANTIDAD, 10) && promo.CANT_INICIAL <= parseInt(element.CANTIDAD, 10)) //  )
                element.VALOR_UNI = (actprom) ? actprom.VALOR : element.CONTROL_VALOR_UNIDAD;
                this.validarPromoGrupo()
            };
            element.TOTAL = (element.CANTIDAD * element.VALOR_UNI);
            element.VALOR_DCTO = funciones.round((element.TOTAL * element.DESCUENTO / 100), 2);
            element.VALOR_IVA = ((element.TOTAL - element.VALOR_DCTO) * element.PORCENTAJE_IVA / 100);
            TOTAL_BRUTO += element.TOTAL;
            TOTAL_IVA += element.VALOR_IVA;
            TOTAL_DESCUENTOS += element.VALOR_DCTO;
            SUBTOTAL = TOTAL_BRUTO - TOTAL_DESCUENTOS;
            TOTAL_PAGAR = TOTAL_BRUTO - TOTAL_DESCUENTOS + TOTAL_IVA;
            ////console.log(element.)
        });

        ////console.log(data_cliente[0][0].LIQUIDA_RENTA);

        if (data_cliente[0].LIQUIDA_RENTA) {
            retenciones.forEach(element => {
                if (element.TIPO_RETENCION === "1") {
                    RENTA += (element.BASE_MINIMA_VENTA <= SUBTOTAL) ? SUBTOTAL * element.PORCENTAJE_RETENCION / 100 : 0;
                    RETENCION += RENTA;
                }
            });
        }

        if (data_cliente[0].LIQUIDA_RETEIVA) {
            retenciones.forEach(element => {
                if (element.TIPO_RETENCION === "2") {
                    RETEIVA += (element.BASE_MINIMA_VENTA <= SUBTOTAL) ? TOTAL_IVA * element.PORCENTAJE_RETENCION / 100 : 0;
                    RETENCION += RETEIVA;
                }
            });
        }

        if (data_cliente[0].LIQUIDA_RETEICA) {
            retenciones.forEach(element => {
                if (element.TIPO_RETENCION === "3") {
                    RETEICA += (element.BASE_MINIMA_VENTA <= SUBTOTAL) ? SUBTOTAL * element.PORCENTAJE_RETENCION / 100 : 0;
                    RETENCION += RETEICA;
                }
            });
        }

        if (data_cliente[0].LIQUIDA_RETEOTROS) {
            retenciones.forEach(element => {
                if (element.TIPO_RETENCION === "4") {
                    RETEOTROS += (element.BASE_MINIMA_VENTA <= SUBTOTAL) ? SUBTOTAL * element.PORCENTAJE_RETENCION / 100 : 0;
                    RETENCION += RETEOTROS;
                }
            });
        }

        TOTAL_PAGAR -= RETENCION;

        const newTotal = {
            TOTAL_BRUTO,
            RETENCION,
            TOTAL_IVA,
            SUBTOTAL,
            TOTAL_DESCUENTOS,
            TOTAL_PAGAR
        }

        this.setState({
            RENTA,
            RETEIVA,
            RETEICA,
            RETEOTROS,
            detalle_factura: newDetalle,
            totales: newTotal
        })
    }

    removeitem = (index) => {
        let newData = this.state.detalle_factura;

        newData.splice(index, 1);

        ////console.log(newData);
        this.setState({ detalle_factura: newData });
        this.calcTotales();
    }

    changeCliente = (client) => {
        const value = client.ID_CLIENTES
        let showDetail = false;
        if (value) {
            if (this.state.PREFIJO !== "") showDetail = true;
            const datasend = {
                method: 'GET',

                headers: {
                    'Content-Type': 'application/json',
                    'empresa': this.state.empresa,
                    'tipo': this.state.tipo,
                }
            }
            fetch(config.servBackEnd + '/invoice/detail/' + value, datasend).then(response => response.json())
                .then(data => {
                    const cData = data.data;
                    const cCliente = cData[0];
                    const cItems = cData[1];
                    const items_barcode = cData[2];
                    const promociones = cData[3];
                    const promociones_grupo = cData[4];
                    const vend = cCliente[0]["VENDEDOR_ASOCIADO"];
                    const list = cCliente[0]["LISTA_CLIENTE"];
                    const fpago = cCliente[0]["FORMA_PAGO_CLIENTE"];
                    this.setState({
                        CLIENTE: value,
                        cod_lista: list,
                        SHOW_DETAIL: showDetail,
                        data_items: cItems,
                        data_cliente: cCliente,
                        VENDEDOR_SELECTED: vend,
                        FORMA_PAGO: fpago,
                        totales: {
                            TOTAL_BRUTO: 0,
                            RETENCION: 0,
                            TOTAL_IVA: 0,
                            SUBTOTAL: 0,
                            TOTAL_DESCUENTOS: 0,
                            TOTAL_PAGAR: 0
                        },
                        RENTA: 0,
                        RETEIVA: 0,
                        RETEICA: 0,
                        RETEOTROS: 0,
                        detalle_factura: [],
                        items_barcode,
                        promociones,
                        promociones_grupo
                    });
                });
        } else {
            //console.log("Seleccione un cliente");
        };

    }

    clearItem = () => {
        this.setState({
            detalle_factura: [],
            totales: {
                TOTAL_BRUTO: 0,
                RETENCION: 0,
                TOTAL_IVA: 0,
                SUBTOTAL: 0,
                TOTAL_DESCUENTOS: 0,
                TOTAL_PAGAR: 0
            },
            RENTA: 0,
            RETEIVA: 0,
            RETEICA: 0,
            RETEOTROS: 0
        })

    }

    saveInvoice = (event) => {
        event.preventDefault();
        this.setState({ show: true });
    }

    enviarInfo = () => {
        this.setState({ show: false });
        event.preventDefault();

        const cliente = this.state.data_cliente[0];
        const { totales } = this.state;
        const { forma_pago } = this.state;
        const { vendedores } = this.state;
        const { detalle_factura } = this.state;
        const valorTexto = Numeroaletras(totales.TOTAL_PAGAR);
        let tmpcurrentForma = []
        let tmpcurrentForma2 = []
        const textFormaPago = (this.state.FORMA_PAGO) ? this.state.FORMA_PAGO.toString() : "";

        forma_pago.forEach(element => {
            if (element.ID_FORMAS_PAGO.toString() === textFormaPago) {
                tmpcurrentForma = element;
            }
            if (element.DESCRIPCION_FORMA_PAGO.toString() === "CONTADO") {
                tmpcurrentForma2 = element;
            }
        });

        const currentForma = (tmpcurrentForma.length > 0) ? tmpcurrentForma : tmpcurrentForma2;

        let currentVend = []
        vendedores.forEach(element => {
            if (element.ID_USUARIO.toString() === this.state.VENDEDOR_SELECTED.toString()) {
                currentVend = element;
            }
        });
        const subtotal_send = totales.SUBTOTAL + totales.TOTAL_DESCUENTOS + totales.TOTAL_IVA;
        const Cabecera = {
            ID_EMPRESA: this.state.empresa,
            CODIGO_EMPRESA: '01',
            CENTRO_OPERACION: '01',
            NUMERO_FACTURA_CABECERA: this.state.NUMERO_FACTURA,
            TIPO_DOCUMENTO_CABECERA: this.state.PREFIJO,
            NUMERO_REMISION: "",
            NUMERO_PEDIDO: "",
            DOCUMENTO_ALTERNO: this.state.ORDEN_COMPRA,
            ID_TRANSACCION: "",
            DOCUMENTO_CLIENTE: cliente.DOCUMENTO_CLIENTE,
            DIGITO_VERIFICACION_CLIENTE: cliente.DV_CLIENTE,
            TIPO_IDENTIFICACION_CLIENTE: cliente.TIPO_IDENTIFICACION,
            NOMBRE_CLIENTE: cliente.NOMBRE_CLIENTE,
            DIRECCION_CLIENTE: cliente.DIRECCION_CLIENTE,
            DEPARTAMENTO_CLIENTE: cliente.NOMBRE_DEPARTAMENTO_CLIENTE,
            CODIGO_POSTAL: cliente.CODIGO_POSTAL,
            CIUDAD_CLIENTE: cliente.NOMBRE_CIUDAD_CLIENTE,
            CODIGO_DEPARTAMENTO_CLIENTE: cliente.CODIGO_DEPARTAMENTO_CLIENTE,
            CODIGO_CIUDAD_CLIENTE: cliente.CODIGO_CIUDAD_CLIENTE,
            TELEFONO_CLIENTE: cliente.TELEFONO_FIJO_CLIENTE,
            EMAIL_CLIENTE: cliente.EMAIL_CLIENTE,
            VENDEDOR: currentVend.NOMBRE_COMPLETO,
            FECHA_DOCUMENTO: this.state.FECHA_CREACION,
            FECHA_VENCIMIENTO_DOCUMENTO: this.state.FECHA_ENTREGA,
            FECHA_DOCUMENTO_ALTERNO: "",
            PORCENTAJE_IVA: 0,
            PORCENTAJE_IMPOCONSUMO: 0,
            TOTAL_BRUTO: totales.TOTAL_BRUTO,
            TOTAL_DESCUENTO_LINEA: totales.TOTAL_DESCUENTOS,
            TOTAL_DESCUENTO_GLOBAL: 0,
            TOTAL_IVA: totales.TOTAL_IVA,
            TOTAL_IMPOCONSUMO: 0,
            TOTAL_RETENCION: totales.RETENCION,
            RET_IVA: this.state.RETEIVA,
            RET_ICA: this.state.RETEICA,
            RET_FUENTE: this.state.RENTA,
            RET_OTROS: this.state.RETEOTROS,
            SUBTOTAL: subtotal_send,
            TOTAL_VENTA: totales.TOTAL_PAGAR,
            CONDICION_PAGO: currentForma.DESCRIPCION_FORMA_PAGO,
            VALOR_LETRAS: valorTexto,
            TASA_MONEDA: "1",
            TIPO_MONEDA: "COP",
            OBSERVACION1: this.state.OBSERVACION_FACTURA,
            OBSERVACION2: "",
            BARRIO: cliente.BARRIO_CLIENTE,
            CODIGO_VENDEDOR: currentVend.CODIGO_VENDEDORES
        }

        let Detalle = []

        detalle_factura.forEach((element, index) => {
            if (element.DESCRIPCION_ITEM !== "") {
                Detalle.push(
                    {
                        ID_EMPRESA: this.state.empresa,
                        CODIGO_EMPRESA: '01',
                        CENTRO_OPERACION: '01',
                        NUMERO_FACTURA_DETALLE: this.state.NUMERO_FACTURA,
                        TIPO_DOCUMENTO_DETALLE: this.state.PREFIJO,
                        INDICE_ITEM: index + 1,
                        ITEM_ID: element.ID_ITEMS,
                        ITEM_DESCRIPCION: element.DESCRIPCION_ITEM,
                        SERIAL: "",
                        UNIDAD_MEDIDA: element.UNIDAD_VENTA,
                        CANTIDAD_1: element.CANTIDAD,
                        CANTIDAD_2: 0,
                        PRECIO_UNITARIO_DETALLE: element.VALOR_UNI,
                        TOTAL_BRUTO_DETALLE: element.TOTAL,
                        DESCUENTO_LINEA_DETALLE: element.VALOR_DCTO,
                        IVA_DETALLE: element.VALOR_IVA,
                        IMPOCONSUMO_DETALLE: 0,
                        PORCENTAJE_IVA_DETALLE: element.PORCENTAJE_IVA,
                        PORCENTAJE_IMPOCONSUMO_DETALLE: 0,
                        PORCENTAJE_DESCUENTO_DETALLE: element.DESCUENTO,
                        OBSERVACION_ITEM: element.OBS_ITEM,
                        BODEGA: element.BODEGA
                    }
                )
            }
        });

        const factura = {
            Tipo: "P",
            Cabecera,
            Detalle
        }

        const datasend = {
            method: 'POST',
            body: JSON.stringify(factura),
            headers: {
                'Content-Type': 'application/json',
                'empresa': this.state.empresa,
                'tipo': this.state.tipo,
                'currentUser': this.state.currentUser,
            }
        };

        fetch(config.servBackEnd + '/invoice/create', datasend).then(response => response.json())
            .then(data => {
                if (data.ok) {
                    const { id } = data;
                    toast({ title: 'Pedido creado', description: 'El documento No ' + data.DOCUMENTO_CREADO + ' se creó satisfactoriamente.', type: 'successful' });
                    this.setState({ showPress: true, id });
                    this.initFactura();
                }
            });


    }

    changeItem = (selectItem) => {
        const newdetalle = this.state.detalle_factura;
        const { data_items } = this.state;
        const { data_cliente } = this.state;
        const { bodegadefault } = this.state;
        const infoCliente = data_cliente[0];
        let currentItem = [];
        let control = true;
        let cont = 0;
        while (control) {
            const item = data_items[cont];
            if (selectItem.ID_ITEMS.toString() === item.ID_ITEMS.toString()) {
                currentItem = item;
                control = false;
            }
            cont++;
        }

        const iva = (infoCliente.LIQUIDA_IVA) ? currentItem.IVA_ITEM : 0
        const precio = funciones.round((infoCliente.INC_IVA) ? (currentItem.PRECIO / (1 + (iva / 100))) : currentItem.PRECIO, 2);
        const cdiscountclient = (data_cliente[0] && data_cliente[0].DESCUENTO) ? data_cliente[0].DESCUENTO : 0
        newdetalle.unshift({
            ID_ITEMS: selectItem.ID_ITEMS,
            REFERENCIA_ITEM: selectItem.REFERENCIA_ITEM,
            DESCRIPCION_ITEM: selectItem.DESCRIPCION_ITEM,
            UNIDAD_VENTA: selectItem.UNIDAD_VENTA,
            CONTROL_VALOR_UNIDAD: precio,
            CANTIDAD: 1,
            DESCUENTO: cdiscountclient,
            VALOR_UNI: precio,
            VALOR_DCTO: 0,
            VALOR_IVA: 0,
            OBS_ITEM: "",
            BODEGA: bodegadefault,
            PORCENTAJE_IVA: iva,
            TOTAL: 0
        });
        this.setState({ detalle_factura: newdetalle });
        this.calcTotales();
    }

    createRetenciones = () => {
        let cont = 0;
        let children = [];
        const { retenciones } = this.state;
        while (cont < 4) {
            if (retenciones[cont]) {
                switch (retenciones[cont].TIPO_RETENCION) {
                    case "1":
                        children.push(<td key={'tr'} >{retenciones[cont].DESCRIPCION_RETENCION + ": " + this.state.RENTA}</td>);
                        break;
                    case "2":
                        children.push(<td key={'ti'} >{retenciones[cont].DESCRIPCION_RETENCION + ": " + this.state.RETEIVA}</td>);
                        break;
                    case "3":
                        children.push(<td key={'tc'} >{retenciones[cont].DESCRIPCION_RETENCION + ": " + this.state.RETEICA}</td>);
                        break;
                    case "4":
                        children.push(<td key={'to'} >{retenciones[cont].DESCRIPCION_RETENCION + ": " + this.state.RETEOTROS}</td>);
                        break;
                    default:
                        children.push(<td key={'t' + cont} ></td>);
                };
            }
            else {
                children.push(<td key={'t' + cont} ></td>);
            }
            cont += 1;
        }
        return children;
    }

    handleClose = () => {
        this.setState({ show: false });
    };

    changeBodegaItem = ({ currentTarget }, i) => {
        const newDetalle = this.state.detalle_factura;
        const id = 'selectbod' + i;
        const selectBox = document.getElementById(id);
        const { value } = selectBox;
        newDetalle.forEach((element, index) => {
            if (i === index) {
                element.BODEGA = value;
            };
        });
        this.setState({ detalle_factura: newDetalle });

    }

    hideModalImp = () => {
        this.setState({ showPress: false, mensajeImp: "" });
    }

    impresionPDF = () => {
        const { id } = this.state;
        const datasend = {
            method: 'GET',
            headers: {
                'Content-Type': 'blob',
                'empresa': this.state.empresa
            }
        }
        fetch(config.servBackEnd + '/files/getpdfpedido/' + id, datasend)
            .then((res) => {
                if (res.ok) return res.blob();
            }).then(function (myBlob) {
                var objectURL = URL.createObjectURL(myBlob);
                document.querySelector('#pdf-frame').src = '';
                document.querySelector('#pdf-frame').src = objectURL;
                objectURL = URL.revokeObjectURL(myBlob);
            }).then(
                function () {
                    window.setTimeout(function () {
                        document.querySelector('#pdf-frame').contentWindow.print();
                    }, 1000)
                })
            .catch((err) => {
                console.error(err);
            });
    }

    enviarCorreo = () => {
        const { id } = this.state;
        const datasend = {
            method: 'GET',
            headers: {
                'Content-Type': 'blob',
                'empresa': this.state.empresa
            }
        }
        fetch(config.servBackEnd + '/files/createsendorder/' + id, datasend)
            .then(data => {
                this.setState({ mensajeImp: "Correo Enviado Correctamente" });
            });
    }

    addItemBarCode = (selectItem) => {
        const newdetalle = this.state.detalle_factura;
        const { data_items } = this.state;
        const { data_cliente } = this.state;
        const { bodegadefault } = this.state;
        const infoCliente = data_cliente[0];
        let currentItem = [];
        let control = true;
        let cont = 0;
        while (control) {
            const item = data_items[cont];
            if (selectItem.ID_ITEMS.toString() === item.ID_ITEMS.toString()) {
                currentItem = item;
                control = false;
            }
            cont++;
        }

        const iva = (infoCliente.LIQUIDA_IVA) ? currentItem.IVA_ITEM : 0
        const precio = funciones.round((infoCliente.INC_IVA) ? (currentItem.PRECIO / (1 + (iva / 100))) : currentItem.PRECIO, 2);
        const cdiscountclient = (data_cliente[0] && data_cliente[0].DESCUENTO) ? data_cliente[0].DESCUENTO : 0

        newdetalle.unshift({
            ID_ITEMS: selectItem.ID_ITEMS,
            REFERENCIA_ITEM: selectItem.REFERENCIA_ITEM,
            DESCRIPCION_ITEM: selectItem.DESCRIPCION_ITEM,
            CANTIDAD: selectItem.CANTIDAD_BARCODE,
            UNIDAD_VENTA: selectItem.UNIDAD_VENTA,
            CONTROL_VALOR_UNIDAD: selectItem.UNIDAD_VENTA,
            DESCUENTO: cdiscountclient,
            VALOR_UNI: precio,
            VALOR_DCTO: 0,
            VALOR_IVA: 0,
            OBS_ITEM: "",
            BODEGA: bodegadefault,
            PORCENTAJE_IVA: iva,
            TOTAL: 0
        });

        this.setState({ detalle_factura: newdetalle });
        this.calcTotales();
    }

    validarPromoGrupo = () => {
        const { promociones_grupo, detalle_factura } = this.state;

        for (let i = 0; i < promociones_grupo.length; i++) {
            const element_prom = promociones_grupo[i];
            element_prom.ACUMULADOR = 0;
            for (let j = 0; j < detalle_factura.length; j++) {
                const element = detalle_factura[j];
                if (element.REFERENCIA_ITEM.startsWith(element_prom.REF_ITEM)) {
                    element_prom.ACUMULADOR += (element.CANTIDAD !== "") ? parseFloat(element.CANTIDAD) : 0
                }
            }
        }


        for (let k = 0; k < detalle_factura.length; k++) {
            const detail_element = detalle_factura[k];
            let cont_prom_as = 0;
            for (let l = 0; l < promociones_grupo.length; l++) {
                const element_prom_asig = promociones_grupo[l];
                if (detail_element.REFERENCIA_ITEM.startsWith(element_prom_asig.REF_ITEM) && element_prom_asig.ACUMULADOR >= element_prom_asig.CANT_INICIAL && element_prom_asig.ACUMULADOR < element_prom_asig.CANT_FINAL) {
                    detail_element.VALOR_UNI = element_prom_asig.VALOR;
                    cont_prom_as = 1;
                }
                if (cont_prom_as === 0) {
                    detail_element.VALOR_UNI = detail_element.CONTROL_VALOR_UNIDAD
                }
            }
        }

        this.setState({ detalle_factura })

    }


    render() {
        const style = {
            color: "white",
            backgroundColor: "DodgerBlue",
            padding: "10px",
            fontFamily: "Arial"
        };
        const mensajeConfirm = "¿Está seguro que desea crear el pedido?";
        const { prefijos } = this.state;
        const { clientes } = this.state;
        // const { data_cliente } = this.state;
        // const { forma_pago } = this.state;
        const { vendedores } = this.state;
        const { detalle_factura } = this.state;
        const { cod_lista } = this.state;
        const { data_items } = this.state;
        const { totales } = this.state;
        const { currentUser } = this.state;
        //const { bodegas } = this.state;
        const { tope, tipo } = this.state;
        const { items_barcode } = this.state;
        const { mostrar_prefijo } = this.state;
        const { defaultDocOrder } = this.state;
        const { user } = this.state;
        // En celular la lista de resultados se cierra al agregar el item, para no tapar el detalle
        const esMovil = typeof window !== 'undefined' && !!window.matchMedia && window.matchMedia('(max-width: 767.98px)').matches;
        const changeCantidad = this.changeCantidad;
        const removeitem = this.removeitem;
        const clearItem = this.clearItem;
        const saveInvoice = this.saveInvoice;
        return (

            <div className="contenedor pedidos-page">
                <iframe id="pdf-frame"></iframe>
                <ModalConfirm show={this.state.show} enviarInfo={this.enviarInfo} handleClose={this.handleClose} mensaje={mensajeConfirm} ></ModalConfirm>
                <ModalImpresion hideModalImp={this.hideModalImp} impresionPDF={this.impresionPDF} enviarCorreo={this.enviarCorreo} showPress={this.state.showPress} mensaje={this.state.mensajeImp}></ModalImpresion>
                <Jumbotron style={style} className="pedidos-title">
                    <h1>Modulo Pedidos</h1>
                </Jumbotron>
                <BackButton />
                <Form onSubmit={saveInvoice}>
                    <Form.Row>
                        <Form.Group as={Col} xs={12} md >
                            <Form.Label>TIPO DOCUMENTO</Form.Label>
                            <Form.Control as="select" onChange={this.changePrefijo} value={this.state.PREFIJO} required>
                                <option value="">Seleccione</option>
                                {prefijos.map(function (currentData, index) {
                                    if (mostrar_prefijo === 1 || (mostrar_prefijo === 0 && currentData.PREFIJO === defaultDocOrder)) {
                                        return <option key={'p' + index} title={currentData.ULTIMO_DIGITO + 1} value={currentData.PREFIJO}>{currentData.PREFIJO}</option>;
                                    } else if (user === "admin" || currentUser === '0') {
                                        return <option key={'p' + index} title={currentData.ULTIMO_DIGITO + 1} value={currentData.PREFIJO}>{currentData.PREFIJO}</option>;
                                    } else {
                                        return null;
                                    }
                                })}
                            </Form.Control>
                        </Form.Group>

                        <Form.Group as={Col} xs={12} md >
                            <Form.Label>CLIENTE</Form.Label>
                            <SearchClient data={clientes} event={this.changeCliente} ></SearchClient>
                        </Form.Group>


                        {/* <Form.Group as={Col} >
                            <Form.Label>FORMA DE PAGO</Form.Label>
                            <Form.Control as="select" onChange={(e) => this.setState({ FORMA_PAGO: e.target.value })} value={this.state.FORMA_PAGO} required >
                                <option value="">Seleccione</option>
                                {forma_pago.map(function (currentData, index) {
                                    return <option key={'p' + index} value={currentData.ID_FORMAS_PAGO}>{currentData.DESCRIPCION_FORMA_PAGO}</option>;
                                })}
                            </Form.Control>
                        </Form.Group> */}

                        <Form.Group as={Col} xs={6} md >
                            <Form.Label>FECHA PEDIDO</Form.Label>
                            <Form.Control type="date" defaultValue={this.state.FECHA_CREACION} disabled />
                        </Form.Group>
                        {/* <Form.Group as={Col} >
                            <Form.Label>FECHA ENTREGA</Form.Label>
                            <Form.Control type="date" onChange={e => this.setState({ FECHA_ENTREGA: e.target.value })} value={this.state.FECHA_ENTREGA} required />
                        </Form.Group> */}
                        <Form.Group as={Col} xs={6} md >
                            <Form.Label>ORDEN DE COMPRA</Form.Label>
                            <Form.Control type="text" maxLength="12" onChange={e => this.setState({ ORDEN_COMPRA: e.target.value })} value={this.state.ORDEN_COMPRA} />
                        </Form.Group>
                        {currentUser === "0" && <Form.Group as={Col} xs={12} md >
                            <Form.Label>VENDEDOR</Form.Label>
                            <Form.Control as="select" onChange={(e) => this.setState({ VENDEDOR_SELECTED: e.target.value })} value={this.state.VENDEDOR_SELECTED} required >
                                <option value="">Seleccione</option>
                                {vendedores.map(function (currentData, index) {
                                    return <option key={'p' + index} value={currentData.ID_USUARIO}>{currentData.NOMBRE_COMPLETO}</option>;
                                })}
                            </Form.Control>
                        </Form.Group>}
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col}>
                            <Form.Label>OBSERVACIONES</Form.Label>
                            <Form.Control as="textarea" rows="1" onChange={(e) => this.setState({ OBSERVACION_FACTURA: e.target.value.toUpperCase() })} value={this.state.OBSERVACION_FACTURA} />
                        </Form.Group>
                    </Form.Row>

                    {this.state.SHOW_DETAIL &&
                        <div>
                            <Row>
                                <Col xs={12} md={3} className="mb-3">
                                    <SearchItem data={data_items} event={this.changeItem} data_barcode={items_barcode} event_barcode={this.addItemBarCode} clean={esMovil}></SearchItem>
                                </Col>
                                <Col>
                                    <Row>
                                        <Col>
                                            <div className="pedidos-cards d-md-none">
                                                {detalle_factura.map(function (element, index) {
                                                    const sinDescuento = element.ID_ITEMS === "" || (tope === 0) || !tope || currentUser !== "0" || tipo === "3";
                                                    return <div className="pedido-item" key={'card' + index}>
                                                        <div className="pedido-item-head">
                                                            <div className="pedido-item-desc">
                                                                <span className="pedido-item-ref">{element.REFERENCIA_ITEM}</span>
                                                                <span>{element.DESCRIPCION_ITEM}</span>
                                                            </div>
                                                            <button type="button" className="pedido-item-remove" aria-label="Quitar item" onClick={() => removeitem(index)}>
                                                                <IoIosRemoveCircle aria-hidden="true" />
                                                            </button>
                                                        </div>
                                                        <div className="pedido-item-fields">
                                                            <label className="pedido-field">
                                                                <span>CANTIDAD</span>
                                                                <Form.Control name="CANTIDAD" step="0.01" min="0.01" type="number" inputMode="decimal" onChange={(e) => changeCantidad(e, index)} disabled={element.ID_ITEMS === ""} value={element.CANTIDAD} />
                                                            </label>
                                                            <label className="pedido-field">
                                                                <span>DSCTO %</span>
                                                                <Form.Control name="DESCUENTO" min="0" max={tope} type="number" inputMode="decimal" onChange={(e) => changeCantidad(e, index)} disabled={sinDescuento} value={element.DESCUENTO} />
                                                            </label>
                                                            <label className="pedido-field">
                                                                <span>VLR. UND.</span>
                                                                <Form.Control name="VALOR_UNI" min="0" type="number" inputMode="decimal" onChange={(e) => changeCantidad(e, index)} disabled={element.ID_ITEMS === "" || cod_lista !== 0} value={element.VALOR_UNI} />
                                                            </label>
                                                        </div>
                                                        <div className="pedido-item-sums">
                                                            <div>Dscto<strong className="currSign">{Intl.NumberFormat('es-MX').format(funciones.round(element.VALOR_DCTO, 2))}</strong></div>
                                                            <div>IVA<strong className="currSign">{Intl.NumberFormat('es-MX').format(funciones.round(element.VALOR_IVA, 2))}</strong></div>
                                                            <div className="pedido-item-total">Total<strong className="currSign">{Intl.NumberFormat('es-MX').format(funciones.round(element.TOTAL, 2))}</strong></div>
                                                        </div>
                                                    </div>
                                                })}
                                            </div>
                                            <div className="pedidos-totales d-md-none">
                                                <div className="pedidos-total-row"><span>TOTAL BRUTO</span><span className="currSign">{Intl.NumberFormat('es-MX').format(funciones.round(totales.TOTAL_BRUTO, 2))}</span></div>
                                                <div className="pedidos-total-row"><span>TOTAL DESCUENTOS</span><span className="currSign">{Intl.NumberFormat('es-MX').format(funciones.round(totales.TOTAL_DESCUENTOS, 2))}</span></div>
                                                <div className="pedidos-total-row"><span>SUBTOTAL</span><span className="currSign">{Intl.NumberFormat('es-MX').format(funciones.round(totales.SUBTOTAL, 2))}</span></div>
                                                <div className="pedidos-total-row"><span>TOTAL IVA</span><span className="currSign">{Intl.NumberFormat('es-MX').format(funciones.round(totales.TOTAL_IVA, 2))}</span></div>
                                                <div className="pedidos-total-row pedidos-total-row--grand"><span>TOTAL</span><span className="currSign">{Intl.NumberFormat('es-MX').format(funciones.round(totales.TOTAL_PAGAR, 0))}</span></div>
                                            </div>
                                            <div className="d-none d-md-block">
                                            <Table striped bordered hover>
                                                <thead>
                                                    <tr>
                                                        {/* <th>CODIGO</th> */}
                                                        <th></th>
                                                        <th>REF.</th>
                                                        <th>DESCRIPCION</th>
                                                        {/*<th>BODEGA</th>*/}
                                                        {/*<th>OBSERVACION</th>*/}
                                                        <th>CANTIDAD</th>
                                                        <th>DESCUENTO</th>
                                                        <th>VLR. UND.</th>
                                                        <th>VLR. DSCTO</th>
                                                        <th>VLR. IVA</th>
                                                        <th>TOTAL</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {detalle_factura.map(function (element, index) {
                                                        return <tr key={'dettr' + index}>
                                                            <td>
                                                                <IconContext.Provider value={{ size: "2em" }}>
                                                                    <IoIosRemoveCircle onClick={() => removeitem(index)} />
                                                                </IconContext.Provider>
                                                            </td>
                                                            <td>{element.REFERENCIA_ITEM}</td>
                                                            <td>{element.DESCRIPCION_ITEM}</td>
                                                            {/*<td><Form.Control id={'selectbod' + index} as="select" onChange={(e) => changeBodegaItem(e, index)} value={element.BODEGA} required>
                                                        <option value="">Seleccione</option>
                                                        {bodegas.map(function (currentData, index) {
                                                            return <option key={'p' + index} value={currentData.ID_BODEGAS}>{currentData.DESCRIPCION_BODEGA}</option>;
                                                        })}
                                                    </Form.Control></td>*/}
                                                            {/*<td> <Form.Control name="OBS_ITEM" type="text" maxLength="200" onChange={(e) => changeCantidad(e, index)} value={element.OBS_ITEM} /></td>*/}
                                                            <td> <Form.Control className="shortinput" name="CANTIDAD" step="0.01" min="0.01" type="number" onChange={(e) => changeCantidad(e, index)} disabled={element.ID_ITEMS === ""} value={element.CANTIDAD} /></td>
                                                            <td> <Form.Control className="shortinput" name="DESCUENTO" min="0" max={tope} type="number" onChange={(e) => changeCantidad(e, index)} disabled={element.ID_ITEMS === "" || (tope === 0) || !tope || currentUser !== "0" || tipo === "3"} value={element.DESCUENTO} /></td>
                                                            <td> <Form.Control className="mediuminput" name="VALOR_UNI" min="0" type="number" onChange={(e) => changeCantidad(e, index)} disabled={element.ID_ITEMS === "" || cod_lista !== 0} value={element.VALOR_UNI} /></td>
                                                            <td className="currSign">{Intl.NumberFormat('es-MX').format(funciones.round(element.VALOR_DCTO, 2))}</td>
                                                            <td className="currSign">{Intl.NumberFormat('es-MX').format(funciones.round(element.VALOR_IVA, 2))}</td>
                                                            <td className="currSign">{Intl.NumberFormat('es-MX').format(funciones.round(element.TOTAL, 2))}</td>
                                                        </tr>
                                                    })}
                                                </tbody>
                                            </Table>
                                            <Table striped bordered hover size="sm" responsive>
                                                <tbody>
                                                    <tr>
                                                        <td>TOTAL BRUTO</td>
                                                        <td className="currSign">{Intl.NumberFormat('es-MX').format(funciones.round(totales.TOTAL_BRUTO, 2))}</td>
                                                        <td>TOTAL DESCUENTOS</td>
                                                        <td className="currSign">{Intl.NumberFormat('es-MX').format(funciones.round(totales.TOTAL_DESCUENTOS, 2))}</td>
                                                        <td>SUBTOTAL</td>
                                                        <td className="currSign">{Intl.NumberFormat('es-MX').format(funciones.round(totales.SUBTOTAL, 2))}</td>
                                                        <td>TOTAL IVA</td>
                                                        <td className="currSign">{Intl.NumberFormat('es-MX').format(funciones.round(totales.TOTAL_IVA, 2))}</td>
                                                        <td>TOTAL</td>
                                                        <td className="currSign">{Intl.NumberFormat('es-MX').format(funciones.round(totales.TOTAL_PAGAR, 0))}</td>
                                                    </tr>
                                                </tbody>
                                            </Table>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row className="d-none d-md-flex">
                                        <Col>
                                            {this.state.SHOW_DETAIL &&
                                                <div>
                                                    <Button className='m-2' type="submit" disabled={detalle_factura.length === 0}>Guardar</Button>
                                                    <Button className='m-2' onClick={clearItem} disabled={detalle_factura.length === 0} >Limpiar</Button>
                                                </div>
                                            }
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </div>
                    }
                    {this.state.SHOW_DETAIL &&
                        <div className="pedidos-actions-mobile">
                            <Button variant="secondary" onClick={clearItem} disabled={detalle_factura.length === 0}>Limpiar</Button>
                            <Button type="submit" disabled={detalle_factura.length === 0}>Guardar</Button>
                        </div>
                    }
                </Form>
            </div>
        );
    }
}
export default (Pedidos);


// WEBPACK FOOTER //
// ./src/components/bussines/pedidos/pedidos.jsx